document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-products-slider-2026="true"]');

  sections.forEach((section) => {
    if (section.dataset.tabsInitialized === 'true') return;
    const tabs = section.querySelectorAll('[data-products-slider-2026-tab]');
    const panels = section.querySelectorAll('[data-products-slider-2026-panel]');
    const ctas = section.querySelectorAll('[data-products-slider-2026-cta]');
    const tabsSwiper = section.querySelector('[data-products-slider-2026-tabs-swiper]');

    if (tabs.length === 0 || panels.length === 0) return;

    if (tabsSwiper && tabsSwiper.dataset.swiperInitialized !== 'true') {
      const checkSwiperLoadedInterval = setInterval(() => {
        if (typeof Swiper !== 'undefined' && tabsSwiper) {
          new Swiper(tabsSwiper, {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 6,
            loop: false,
            draggable: true,
            freeMode: {
              enabled: true,
              sticky: true,
            },
            watchOverflow: true,
            cssMode: true,
            mousewheel: {
              forceToAxis: true,
            },
          });
          tabsSwiper.dataset.swiperInitialized = 'true';
          clearInterval(checkSwiperLoadedInterval);
        }
      }, 200);
    }

    const setActive = (tabId, tabUrl, tabLabel) => {
      tabs.forEach((tab) => {
        const isActive = tab.getAttribute('data-tab-id') === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.classList.toggle('bg-gray50', isActive);
        tab.classList.toggle('border-gray40', isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      ctas.forEach((cta) => {
        if (!tabUrl) {
          cta.setAttribute('hidden', 'hidden');
        } else {
          cta.setAttribute('href', tabUrl);
          cta.removeAttribute('hidden');
        }
      });

      if (tabLabel) {
        section.setAttribute('selected_products_category', tabLabel);
      }

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-tab-id') === tabId;
        panel.hidden = !isActive;
        if (isActive) {
          panel.querySelectorAll('.ProductsSlider__swiper').forEach((swiperEl) => {
            if (swiperEl.dataset.swiperInitialized !== 'true' && typeof window.initProductsSlider2026Swiper === 'function') {
              window.initProductsSlider2026Swiper(swiperEl);
            }

            if (swiperEl.swiper) {
              swiperEl.swiper.updateSize();
              swiperEl.swiper.updateSlides();
              swiperEl.swiper.updateProgress();
              swiperEl.swiper.updateSlidesClasses();
              swiperEl.swiper.update();
            }
          });
        }
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', async () => {
        const tabId = tab.getAttribute('data-tab-id');
        const tabUrl = tab.getAttribute('data-tab-url') || '';
        const tabLabel = tab.getAttribute('data-tab-label') || '';
        if (!tabId) return;
        setActive(tabId, tabUrl, tabLabel);

        const productCategory = section.getAttribute('selected_products_category') || 'unknown_section';
        const tabPayload = {
          event: 'carousel_tab_clicked',
          device_type: window.deviceType || '',
          user_id: window.customerData?.id ? window.customerData.id : '',
          section: 'homepage_carousel',
          element: 'category_tab',
          element_value: tabLabel || '',
          interaction_type: 'click',
          product_category: productCategory,
        };
        await dataLayerPromise(tabPayload);
      });
    });

    const activeTab = Array.from(tabs).find((tab) => tab.classList.contains('is-active')) || tabs[0];
    if (activeTab) {
      setActive(
        activeTab.getAttribute('data-tab-id'),
        activeTab.getAttribute('data-tab-url') || '',
        activeTab.getAttribute('data-tab-label') || ''
      );
    }

    if (section.dataset.analyticsBound !== 'true') {
      const links = section.querySelectorAll('li a');
      links.forEach((link) => {
        link.addEventListener('click', async (ev) => {
          ev.preventDefault();
          const productName = link.getAttribute('data-product');
          const context = section.getAttribute('analytics_context') || 'homepage_carousel';
          const productCategory = section.getAttribute('selected_products_category') || 'unknown_section';
          const payload = {
            event: 'product_tile_clicked',
            section: context,
            element: 'big_product_tile',
            element_value: productName || '',
            interaction_type: 'click',
            product_category: productCategory,
          };

          await dataLayerPromise(payload);
          continueLinkClickEvent(ev, link.href);
        });
      });
      section.dataset.analyticsBound = 'true';
    }

    section.dataset.tabsInitialized = 'true';
  });
});
